/**
 * Created by hernanherreros on 2019-08-31
 */

import * as React from 'react'
import styled from 'styled-components'

import { Input } from 'antd'

interface Props {
  onChange: (text: string) => void;
}

const { TextArea } = Input


export default function Comment ({ onChange }: Props) {
  return (
    <Container>
      <TextArea style={{ width: '100%' }} rows={4} onChange={(e: any) => onChange(e.target.value)} placeholder="Se podría mejorar..."/>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
 
  margin: 20px 0;
  margin-bottom: 50px;
`